import type { ReactNode } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Actions } from '../Action';

interface ActionMenuItemProps {
  readonly actions: Actions;
  readonly action: string;
  /** Override the action's default label. */
  readonly label?: ReactNode;
  readonly children?: ReactNode;
}

/**
 * Render a single named action as a Bootstrap `Dropdown.Item`. Renders nothing
 * when the action is absent (hidden); disabled when present but `enabled` is
 * false. For use inside a `Dropdown.Menu` (see `ActionDropdown`).
 */
export const ActionMenuItem = ({ actions, action, label, children }: ActionMenuItemProps) => {
  const resolved = actions[action];
  if (!resolved) return null;
  return (
    <Dropdown.Item disabled={!resolved.enabled} onClick={resolved.execute}>
      {resolved.icon && <FontAwesomeIcon icon={resolved.icon} className="me-2" />}
      {children ?? label ?? resolved.label ?? action}
    </Dropdown.Item>
  );
};
